import { sendRequest } from 'best-modules/vue-utils'

const loginFirst = (credentials: { email: string; password: string }) => {
  return sendRequest({
    name: 'loginFirst',
    method: 'post',
    url: '/auth/login',
    payload: credentials,
  })
}

const loginSecond = (userId: number, code: string) => {
  return sendRequest({
    name: 'loginSecond',
    method: 'post',
    url: '/auth/2fa',
    payload: {
      userId,
      code,
    },
  })
}

const logout = () => {
  return sendRequest({
    name: 'logout',
    method: 'post',
    url: '/auth/logout',
  })
}

const resetPasswordSendSms = (phone: string) => {
  return sendRequest({
    name: 'resetPasswordSendSms',
    method: 'post',
    url: '/auth/resetPassword',
    payload: {
      phone,
    },
  })
}

const confirmResetPassword = (credentials: {
  password: string
  code: string
}) => {
  return sendRequest({
    name: 'confirmResetPassword',
    method: 'post',
    url: '/auth/confirmPassword',
    payload: {
      password: credentials.password,
      code: credentials.code,
    },
  })
}

export {
  loginFirst,
  loginSecond,
  logout,
  resetPasswordSendSms,
  confirmResetPassword,
}
